import { Component } from "react"
import PropTypes from "prop-types"
import classnames from "classnames"
import parse from "html-react-parser"

import { compactInteger } from "humanize-plus"
import { connectionShape } from "app/lib/shared_prop_types"
import appletOrConnection from "shared/lib/use_applet_or_connection"
import userCountIcon from "images/web/applet_card/user-count-icon.svg"
import { planNameBadge } from "shared/utils/tiers"

import "./small_applet_card.module.scss"

export default class Meta extends Component {
  render() {
    const { applet } = this.props
    const showInstalls = applet.installs_count > 0
    const humanizedInstallNumber = showInstalls && compactInteger(applet.installs_count, 1)
    const needsProBadge = applet.pro_features || applet.intermediate_pro_features

    return (
      <div className={classnames("meta", { badged: needsProBadge })}>
        {showInstalls && (
          // role="img" lets the aria-label name the count; a bare div has the generic role, which cannot be named.
          <div
            className="installs"
            role="img"
            aria-label={`${humanizedInstallNumber} users enabled this ${appletOrConnection(applet)}`}
            title={`${humanizedInstallNumber} users enabled this ${appletOrConnection(applet)}`}
          >
            <span className="verified">
              <img src={userCountIcon} alt="" loading="lazy" width="12" height="12" />
            </span>
            <span className="number">{humanizedInstallNumber}</span>
          </div>
        )}
        {needsProBadge && (
          <span title={`Applet has pro features`} className="card-badge">
            {parse(planNameBadge(applet.pro_features ? "Pro+" : "Pro"))}
          </span>
        )}
      </div>
    )
  }
}

Meta.propTypes = {
  applet: connectionShape.isRequired,
  mainService: PropTypes.object,
}
